import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Route, Switch } from 'react-router-dom';
import { translate, Trans } from 'react-i18next'

import moment from 'moment';
import MainNavigation from '../layout/MainNavigation';
import SideBar from '../layout/SideBar';
import Content from '../layout/Content';
import Button from '../layout/Button';
import { Icon } from '../icons';
import EventList from '../events/List';
import EventCalendar from '../events/Calendar';

import styles from './events.scss';

import {
  setSelectedDate
} from '../../actions/dateSelector';

class Events extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {t, events, loadingEvents, activeEventId, selectedDate, selectedYear, setSelectedDate } = this.props;

    return (
      <div>
        <div className="grid calendar-page">
          <SideBar>
            <EventList events={events} loading={loadingEvents} activeEventId={activeEventId} />
          </SideBar>
          <Content>
            <div className="calendar-navigation">
              <Button onClick={() => setSelectedDate(moment(new Date()))}>{t('TODAY')}</Button>
              <Button onClick={() => setSelectedDate(moment(selectedDate).subtract(1, 'year'))} className="btn-left"><Icon className="btn-arrow" type="arrow-left" /></Button>
              <Button onClick={() => setSelectedDate(moment(selectedDate).add(1, 'year'))} className="btn-right"><Icon className="btn-arrow" type="arrow-right" /></Button>
              <h1 className="calendar-year">{selectedYear}</h1>
            </div>
            <EventCalendar events={events} loading={loadingEvents} selectedYear={selectedYear} />
          </Content>
        </div>
        <MainNavigation />
      </div>
    );
  }
}

export default translate('events')(withRouter(connect(({ events, ui }, { match }) =>({
  events: events.data,
  loadingEvents: events.fetching,
  activeEventId: match.params.eventId,
  selectedDate: ui.dateSelector.date,
  selectedYear: new Date(ui.dateSelector.date).getFullYear()
}),
dispatch => ({
  setSelectedDate: (date) => dispatch(setSelectedDate(date))
}))(Events)));



// WEBPACK FOOTER //
// ./src/components/pages/Events.js